export default function MultiStepArrowIcon({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fill="#C43535"
        d="M6.25 17.5h7.188v1.875l5.937-4.688L13.437 10v1.875H6.25V17.5Z"
      />
      <path
        fill="#DC4A4A"
        d="m15.252 11.434-4.94 3.899v-2.207h-2.5v.937A2.188 2.188 0 0 0 10 16.251h7.396l1.979-1.563-4.123-3.254Z"
      />
      <path
        fill="#E7B541"
        d="M3.438 12.813h7.187v1.874L16.563 10l-5.938-4.688v1.875H3.437v5.625Z"
      />
      <path
        fill="#F9CB6E"
        d="m12.44 6.746-4.94 3.9V8.438H5v.938a2.188 2.188 0 0 0 2.188 2.187h7.395l1.98-1.562-4.123-3.255Z"
      />
      <path
        fill="#40873C"
        d="M.625 8.125h7.188V10l5.937-4.688L7.812.625V2.5H.625v5.625Z"
      />
      <path
        fill="#52A04F"
        d="M7.813 2.5H2.188v2.188a2.188 2.188 0 0 0 2.187 2.187h7.396l1.979-1.563L7.812.625V2.5Z"
      />
      <path
        fill="#fff"
        d="M9.688 6.25V3.437a.312.312 0 0 0-.534-.22l-.937.937.442.442.404-.404V6.25h-.625v.625h1.875V6.25h-.625Zm3.125 5.625h-2.188a.313.313 0 0 1-.2-.553l1.395-1.162a1.02 1.02 0 0 0 .368-.785.625.625 0 1 0-1.25 0h-.625a1.25 1.25 0 1 1 2.5 0 1.642 1.642 0 0 1-.594 1.265l-.73.61h1.324v.625Zm2.812 2.031a1.093 1.093 0 0 0-1.094-1.094h-1.094v.626h1.094a.469.469 0 1 1 0 .937h-.781V15h.781a.469.469 0 1 1 0 .938h-1.094v.624h1.094a1.094 1.094 0 0 0 .765-1.875 1.09 1.09 0 0 0 .329-.78Z"
      />
      <path
        fill="currentColor"
        d="m19.568 14.442-4.064-3.208 1.252-.989a.312.312 0 0 0 0-.49l-4.064-3.209 1.252-.988a.312.312 0 0 0 0-.49L8.006.38A.312.312 0 0 0 7.5.625v1.563H.625a.313.313 0 0 0-.313.312v5.625a.313.313 0 0 0 .313.313h2.5v4.375a.313.313 0 0 0 .313.312h2.5V17.5a.313.313 0 0 0 .312.313h6.875v1.562a.312.312 0 0 0 .506.245l5.938-4.687a.312.312 0 0 0 0-.49v-.001ZM.938 2.812h6.875a.313.313 0 0 0 .312-.312V1.27l5.12 4.043-5.12 4.042v-1.23a.312.312 0 0 0-.313-.312H.937v-5ZM3.75 8.439H7.5V10a.312.312 0 0 0 .506.245l4.181-3.3L16.058 10l-5.12 4.043v-1.23a.312.312 0 0 0-.313-.313H3.75V8.438Zm10 10.292V17.5a.312.312 0 0 0-.313-.312H6.564v-4.063h3.75v1.563a.312.312 0 0 0 .506.245l2.619-2.067v.572h1.093a.469.469 0 1 1 0 .937h-.781V15h.781a.469.469 0 1 1 0 .938h-1.094v.625h1.094a1.093 1.093 0 0 0 .765-1.875 1.093 1.093 0 0 0-.765-1.875h-1.026L15 11.632l3.87 3.056-5.12 4.042Z"
      />
      <path
        fill="currentColor"
        d="M9.063 4.192V6.25h-.625v.625h1.875V6.25h-.625V3.437a.312.312 0 0 0-.534-.22l-.937.937.442.442.404-.404Zm3.75 7.058h-1.324l.73-.61a1.642 1.642 0 0 0 .594-1.265 1.25 1.25 0 0 0-2.5 0h.625a.625.625 0 0 1 1.25 0 1.018 1.018 0 0 1-.368.785l-1.395 1.162a.313.313 0 0 0 .2.553h2.188v-.625Z"
      />
    </svg>
  );
}
